import Image from './image.vue'
import Nodata from './nodata.vue'
import Loading from './loading.vue'
import PartialLoading from './partial-loading.vue'
import MpmField from './MpmField.vue'

export default {
  'mpm-image': Image,
  'mpm-nodata': Nodata,
  'mpm-loading': Loading,
  'mpm-partial-loading': PartialLoading,
  'mpm-field': MpmField,
}
